import {
  COLUMNS_CONFIG,
  DEFAULT_COLUMNS,
  FIELDS,
  ORGANIZATION_SUBSCRIPTIONS,
} from 'frontend/client-communication-templates/client-communication-templates-table-helpers'
import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'

export const OrganizationClientCommunicationTemplateDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,
  subscriptions: ORGANIZATION_SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}
